module.exports = __webpack_public_path__ + "img/phone-dist.ea545875.svg";